import React, { createContext, useState, useContext, useEffect } from "react";
import { setAuthToken } from "../api"; // adjust path if needed
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("token"));

  // Rehydrate from localStorage (no longer needed here, but keeping for reference or safety if you prefer, 
  // actually we can just remove the useEffect for rehydrate since it's done in useState)

//  Sync axios header when token changes
  useEffect(() => {
  if (token) {
    setAuthToken(token);
  }
}, [token]);

  const login = (jwtToken, userData) => {
    setToken(jwtToken);
    setUser(userData);
    localStorage.setItem("token", jwtToken);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
  setToken(null);
  setUser(null);
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  setAuthToken(null); // VERY IMPORTANT
};

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);